<template>
    <div class="profileNavigation">
        <nav class="nav">
            <div class="navItems">
                <Button
                    v-if="!isEmpty(feedSize.entries)"
                    tabindex="0"
                    appearance="tabButton"
                    size="large"
                    @click="$emit('changeSelected', 'entries')">
                    <span class="emphasized">{{ feedSize.entries }}</span> {{ entryLabel }}
                    <div class="indicator"
                        v-if="isSelected === 'entries'"></div>
                </Button>
                <Button
                    v-if="isOwnOrAdmin() && !isEmpty(feedSize.entryDrafts) && !feedSizeLoading"
                    tabindex="0"
                    appearance="tabButton"
                    size="large"
                    @click="$emit('changeSelected', 'entryDrafts')">
                    <span class="emphasized">{{ feedSize.entryDrafts }}</span> {{ entryDraftLabel }}
                    <div class="indicator"
                        v-if="isSelected === 'entryDrafts'"></div>
                </Button>
                <div class="divider"
                    v-if="isOwnOrAdmin() && (!isEmpty(feedSize.entries) || !isEmpty(feedSize.entryDrafts)) && (!isEmpty(feedSize.posts) || !isEmpty(feedSize.postDrafts)) && !feedSizeLoading">
                </div>
                <Button
                    v-if="!isEmpty(feedSize.posts) && !feedSizeLoading"
                    tabindex="0"
                    appearance="tabButton"
                    size="large"
                    @click="$emit('changeSelected', 'posts')">
                    <span class="emphasized">{{ feedSize.posts }}</span> {{ postLabel }}
                    <div class="indicator"
                        v-if="isSelected === 'posts'"></div>
                </Button>
                <Button
                    v-if="isOwnOrAdmin() && !isEmpty(feedSize.postDrafts) && !feedSizeLoading"
                    tabindex="0"
                    appearance="tabButton"
                    size="large"
                    @click="$emit('changeSelected', 'postDrafts')">
                    <span class="emphasized">{{ feedSize.postDrafts }}</span> {{ postDraftLabel }}
                    <div class="indicator"
                        v-if="isSelected === 'postDrafts'"></div>
                </Button>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'ProfileNavigation',
        props: {
            isSelected: String,
            feedSize: Object,
            feedSizeLoading: Boolean,
            id: String
        },
        computed: {
            entryLabel() {
                if(this.feedSize.entries === 1) {
                    return this.siteContent.entry
                } else {
                    return this.siteContent.entries
                }
            },
            postLabel() {
                if(this.feedSize.posts === 1) {
                    return this.siteContent.post
                } else {
                    return this.siteContent.posts
                }
            },
            entryDraftLabel() {
                if(this.feedSize.entryDrafts === 1) {
                    return this.siteContent.draft
                } else {
                    return this.siteContent.drafts
                }
            },
            postDraftLabel() {
                if(this.feedSize.postDrafts === 1) {
                    return this.siteContent.draft
                } else {
                    return this.siteContent.drafts
                }
            }
        },
        methods: {
            isOwnOrAdmin() {
                if(this.auth.id === null) {
                    return false
                } else {
                    var isOwn   = this.auth.slug === this.id
                    var isAdmin = this.permissions.isAdmin

                    return isOwn || isAdmin
                }
            },
            isEmpty(itemCount) {
                return itemCount === 0
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .profileNavigation {
        display: flex;
        position: relative;
        width: 100%;
        z-index: 1;
        margin-bottom: 2rem;
    }

    .nav {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
    }

    .navItems {
        display: flex;
        color: var(--color-white-important);
        align-items: center;
    }

    .divider {
        width: 1px;
        background: var(--color-black);
        margin: 0 1rem;
        height: 2.5rem;
    }

    @media all and (max-width: 720px) {
        .profileNavigation {
            overflow-x: scroll;
            padding: 0 1rem;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        .divider {
            height: 2rem;
        }
    }
</style>
